module.exports = __webpack_public_path__ + "static/media/bank_icon.372e2c51.svg";